export default __webpack_public_path__ + "static/mystery-bottle-97ef240280096f2160253b87785c6628.png";